import { useState } from "react";
import { toast } from "sonner";
import { Check, X, Loader2, FileClock, Eye } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { api, fileUrl } from "../lib/api";

export const PendingDocRow = ({ req, empId, onDone, showEmployee }) => {
  const [exp, setExp] = useState(req.expiry_date || "");
  const [busy, setBusy] = useState(false);
  const act = async (ok) => {
    let reason = "";
    if (!ok) { reason = window.prompt("سبب الرفض (اختياري):") ?? null; if (reason === null) return; }
    setBusy(true);
    try {
      if (ok) await api.approveDocRequest(empId, req.id, { expiry_date: exp || null });
      else await api.rejectDocRequest(empId, req.id, { reason });
      toast.success(ok ? "تم اعتماد الوثيقة" : "تم رفض الوثيقة");
      onDone && onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر تنفيذ العملية"); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid={`doc-req-${req.id}`} className="flex flex-wrap items-center gap-2 rounded-lg border border-amber-200 bg-white p-2.5">
      <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-bold text-amber-800">بانتظار الموافقة</span>
      <span className="text-sm font-semibold text-slate-800">{req.label}</span>
      {showEmployee && <span className="text-xs text-slate-500">— {req.employee_name}{req.branch ? ` · ${req.branch}` : ""}</span>}
      <a href={fileUrl(req.attachment_id)} target="_blank" rel="noreferrer" data-testid={`doc-req-view-${req.id}`} className="inline-flex items-center gap-1 text-xs text-blue-700 hover:underline">
        <Eye className="h-3.5 w-3.5" /> عرض
      </a>
      <div className="ms-auto flex items-center gap-1.5">
        <span className="text-[11px] text-slate-500">تاريخ الانتهاء</span>
        <Input type="date" dir="ltr" value={exp} onChange={(e) => setExp(e.target.value)} data-testid={`doc-req-exp-${req.id}`} className="h-8 w-36 text-xs" />
        <Button size="sm" disabled={busy} onClick={() => act(true)} data-testid={`doc-req-approve-${req.id}`} className="h-8 gap-1 bg-emerald-600 hover:bg-emerald-700">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Check className="h-3.5 w-3.5" />} قبول
        </Button>
        <Button size="sm" variant="outline" disabled={busy} onClick={() => act(false)} data-testid={`doc-req-reject-${req.id}`} className="h-8 gap-1 border-rose-200 text-rose-600 hover:bg-rose-50">
          <X className="h-3.5 w-3.5" /> رفض
        </Button>
      </div>
    </div>
  );
};

export const PendingDocsCard = ({ employee, onDone }) => {
  const [hidden, setHidden] = useState(new Set());
  const reqs = (employee.pending_documents || []).filter((r) => r.status === "pending" && !hidden.has(r.id));
  if (!reqs.length) return null;
  return (
    <div data-testid="pending-docs-card" className="space-y-2 rounded-xl border border-amber-200 bg-amber-50/60 p-3">
      <p className="flex items-center gap-1.5 text-xs font-semibold text-amber-800"><FileClock className="h-3.5 w-3.5" /> وثائق رفعها الموظف من التطبيق — بانتظار موافقتك</p>
      {reqs.map((r) => (
        <PendingDocRow key={r.id} req={r} empId={employee.id} onDone={() => { setHidden((h) => new Set(h).add(r.id)); onDone && onDone(); }} />
      ))}
    </div>
  );
};
